import { asAPIError } from 'api/utils/APIError';
import { ErrorCode } from 'api/utils/ErrorCode';

const MODAL_SUB_CODES = new Set<string>([
  ErrorCode.DEALER_INVALID,
  ErrorCode.DEALER_ACCESS_DENIED,
  ErrorCode.ACCOUNT_ACCESS_DENIED,
  ErrorCode.FORBIDDEN,
]);

const MODAL_STATUS_CODES = new Set([403]);

const MODAL_MESSAGE_PATTERNS = [/invalid\s+dealer/i, /dealer.*not\s+found/i, /dealer.*access/i];

/**
 * Returns true if this error should be displayed in a modal rather than a toast.
 * Matches on subCode when available, falls back to HTTP status code,
 * then message patterns for endpoints that don't yet send subCode.
 */
export default function isModalError(error: Error): boolean {
  const apiError = asAPIError(error);
  if (!apiError) return false;

  if (apiError.subCode && MODAL_SUB_CODES.has(apiError.subCode)) {
    return true;
  }

  if (MODAL_STATUS_CODES.has(apiError.statusCode)) {
    return true;
  }

  return MODAL_MESSAGE_PATTERNS.some((pattern) => pattern.test(error.message));
}
